import { Box } from "@chakra-ui/react";
import { PresenceType } from "@keita/lanepatrol-sdk";
import { MapColoringLegendItem } from "./MapColoringLegendItem";
import { getBooleanColor } from "../../../../map/utils/map-utils";
import { CraAttributeUtils } from "../../../../coding/utils/attribute-utils";

export const MapColoringTreatment: React.FC = () => {
  return (
    <Box>
      <MapColoringLegendItem color={getBooleanColor(true)}>
        {CraAttributeUtils.getOptionLabel(PresenceType.Present)}
      </MapColoringLegendItem>
      <MapColoringLegendItem color={getBooleanColor(false)}>
        {CraAttributeUtils.getOptionLabel(PresenceType.NotPresent)}
      </MapColoringLegendItem>
    </Box>
  );
};
